/** What joins the parts of a line such as "Due Wed 28 Oct, likely Fri 13 Nov · you're away …". */
const SEPARATOR = ' · '

/**
 * A line of parts joined by " · " that wraps between the parts first: "Due Wed 28 Oct, likely
 * Fri 13 Nov ·" / "you're away 26 Oct – 6 Nov" instead of breaking a date in two. A part longer
 * than the line still wraps inside. The text stays the same for copying and screen readers.
 */
export function Parts({ text }: { text: string }) {
  const parts = text.split(SEPARATOR)
  return parts.map((part, i) => (
    // biome-ignore lint/suspicious/noArrayIndexKey: the parts of one fixed string, in order
    <span key={i}>
      <span className="inline-block max-w-full">
        {part}
        {i < parts.length - 1 ? '\u00a0·' : null}
      </span>
      {i < parts.length - 1 ? ' ' : null}
    </span>
  ))
}
